import './author-hero.html.twig';
import './author-hero.scss';